import { ImgHTMLAttributes } from 'react';
import PropTypes from 'prop-types';

import ParsedMarkdown from '../ParsedMarkdown';
import Nullable from '../../../../../shared/nullable';
import { withCssModulesClassNames } from '../../../common/nextMigrationHelpers';
import { default as styles } from '../../../scss/components/Card.module.scss';

const withCssModulesClassNamesHandler = withCssModulesClassNames(styles);

const FILENAME_REGEX = /.+\.(\w{3,4})$/;
export const AccessibleImage = ({
  alt: _alt,
  title: _title,
  ...props
}: ImgHTMLAttributes<HTMLImageElement>) => {
  let alt = _alt?.trim() ?? '';
  if (FILENAME_REGEX.test(alt)) {
    alt = '';
  }
  const title = !alt ? undefined : _title;

  // eslint-disable-next-line react/jsx-props-no-spreading,@next/next/no-img-element
  return <img {...props} alt={alt} title={title} />;
};

interface CardRichCopyProps {
  text?: {
    markdown: Nullable<string>;
  };
  fontSizeClassName?: string;
}

const CardRichCopy = ({ text, fontSizeClassName }: CardRichCopyProps) => {
  if (!text?.markdown) {
    return null;
  }

  return (
    <div className={withCssModulesClassNamesHandler('card__copy')}>
      <ParsedMarkdown
        options={{
          forceBlock: true,
          overrides: {
            p: {
              props: {
                className: fontSizeClassName,
              },
            },
            img: AccessibleImage,
          },
        }}
      >
        {text.markdown}
      </ParsedMarkdown>
    </div>
  );
};

CardRichCopy.defaultProps = {
  text: {
    markdown: null,
  },
  fontSizeClassName: '',
};

CardRichCopy.propTypes = {
  text: PropTypes.shape({
    markdown: PropTypes.string,
  }),
  fontSizeClassName: PropTypes.string,
};

export default CardRichCopy;
